import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import * as qs from "query-string";
import ResultsSection from "./ResultsSection";
import Loader from "../../components/Loader/Loader";
// import { colors } from "../../resources/ThemeColors";
import MapContainer from "../../components/Map";
import { breakpoints } from "../../Media";
import renderIf from "render-if";
import axios from "axios";
import { http } from "../../utils/http";

const MainDiv = styled.div`
  height: 88vh;
  width: 98vw;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
  overflow-x: hidden;
  @media (max-width: ${breakpoints.mobileMin}) {
    display: none;
  }
  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    display: none;
  }
`;

const LoadingDiv = styled.div`
  height: 75vh;
  width: 98vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ResultsDiv = styled.div`
  height: 80vh;
  width: 53vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: ${breakpoints.mobileMin}) {
    height: auto;
    width: 100%;
    margin-bottom: 2em;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }
  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    height: auto;
    width: auto;
    margin-bottom: 2em;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
  }
`;

const ResultsTitleDiv = styled.div`
  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 2em;
  padding-bottom: 1em;
`;

const ResultsTitle = styled.h3`
  font-size: 1.6em;
  font-weight: 700;
  margin-left: 1em;
  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1.2em;
  }
  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 1.4em;
  }
`;

const MapDiv = styled.div`
  height: 80vh;
  width: 45vw;
  background-color: gray;
  overflow-x: hidden;
  position: fixed; no-repeat;
  left: 55%;
  z-index: -20;
  @media (max-width: ${breakpoints.mobileMin}) {
    display: none;
  }
  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    display: none;
  }
`;

// this div is only displayed in mobile max views and mobile min views.
// it is not displayed in desktop views.
// this is the view without the map.
const AltDiv = styled.div`
  display: none;
  @media (max-width: ${breakpoints.mobileMin}) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    width: 98vw;
  }
  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    display: flex;
    height: auto;
  }
`;

let API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

class Results extends Component {
  state = {
    location: null,
    service: "",
    currentUserLocation: {},
    filteredSalons: [],
    mapLoading: false,
    salons: [],
    error: null,
    pageLoading: false,
  };

  componentDidMount() {
    this.setState({ pageLoading: true });
    const queries = qs.parse(this.props.location.search);
    this.setState({
      location: queries.city,
      service: queries.query,
      mapLoading: true,
      error: null,
    });
    const qsalons = this._request(queries.query, queries.city);
    qsalons.then((a) => {
      this.setState({ salons: a });
    });

    if (queries.city !== undefined) {
      axios
        .post(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${queries.city}&key=${API_KEY}`
        )
        .then((response) => {
          var responseLocation = response.data.results[0].geometry.location;
          localStorage.setItem(
            "userLocation",
            JSON.stringify(responseLocation)
          );
          this.setState({
            currentUserLocation: responseLocation,
            service: queries.query,
            location: queries.city,
            mapLoading: false,
          });
        });
    } else {
      navigator?.geolocation.getCurrentPosition(
        ({ coords: { latitude: lat, longitude: lng } }) => {
          const pos = { lat, lng };
          const geocoder = new this.props.google.maps.Geocoder();
          this.geocodeLatLng(geocoder, pos);
          localStorage.setItem("userLocation", JSON.stringify(pos));
          this.setState({
            currentUserLocation: pos,
            service: queries.query,
            mapLoading: false,
          });
        }
      );
    }

    this.setState({ pageLoading: false });
  }

  _request = async (query, city) => {
    try {
      const response = await http.get(
        `/api/salon/query/?query=${query}&city=${city}`
      );
      let res = await response.data;
      return res;
    } catch (error) {
      this.setState({ error });
    }
  };

  geocodeLatLng = (geocoder, pos) => {
    geocoder.geocode({ location: pos }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          this.setState({
            location: results[0].address_components[1].long_name,
          });
          localStorage.setItem(
            "queryLocation",
            results[0].address_components[1].long_name
          );
        }
      } else {
        window.alert("Geocoder failed, map may not be displayed properly");
      }
    });
  };

  render() {
    return (
      <>
        {renderIf(this.state.mapLoading === true)(
          <LoadingDiv>
            <Loader />
          </LoadingDiv>
        )}
        {renderIf(this.state.mapLoading === false)(
          <>
            {renderIf(this.state.error === null)(
              <>
                <MainDiv>
                  <ResultsDiv>
                    <ResultsTitleDiv>
                      {renderIf(this.state.location !== null)(
                        <ResultsTitle>
                          HairQ Points in {this.state.location}
                        </ResultsTitle>
                      )}
                      {renderIf(this.state.location === null)(
                        <ResultsTitle>HairQ Points</ResultsTitle>
                      )}
                    </ResultsTitleDiv>
                    <ResultsSection
                      salons={this.state.salons}
                      searchLocation={this.state.location}
                      searchService={this.state.service}
                      mapQueryPosition={this.state.currentUserLocation}
                    />
                  </ResultsDiv>
                  <MapDiv>
                    <MapContainer
                      salons={this.state.salons}
                      searchLocation={this.state.location}
                      mapLocation={this.state.currentUserLocation}
                    />
                  </MapDiv>
                </MainDiv>
                <AltDiv>
                  <ResultsDiv>
                    <ResultsTitleDiv>
                      {renderIf(this.state.location !== null)(
                        <ResultsTitle>
                          HairQ Points in {this.state.location}
                        </ResultsTitle>
                      )}
                      {renderIf(this.state.location === null)(
                        <ResultsTitle>HairQ Points</ResultsTitle>
                      )}{" "}
                    </ResultsTitleDiv>
                    <ResultsSection
                      salons={this.state.salons}
                      searchLocation={this.state.location}
                      searchService={this.state.service}
                      mapQueryPosition={this.state.currentUserLocation}
                    />
                  </ResultsDiv>
                </AltDiv>
              </>
            )}
            {renderIf(this.state.error !== null)(
              <MainDiv
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "center",
                }}
              >
                <p style={{ color: "red", marginTop: "4em" }}>
                  Sorry, something went wrong, try again later.
                </p>
              </MainDiv>
            )}
          </>
        )}
      </>
    );
  }
}

export default withRouter(Results);
